// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import RichText from '/react4xp/components/RichText'
import Image from '/react4xp/components/Image'
import Video, { VideoProps } from '/react4xp/components/Video'
import Link from '/react4xp/components/Link'

// css
import './index.scss'

// types
export interface EntryCardProps {
    className?: string
    isAnimated?: boolean
    boxColor?: 'beige' | 'green-light'
    invert?: boolean
    image?: {
        src?: string
        srcSmall?: string
        alt?: string
    }
    video?: VideoProps
    title?: string
    content?: string
    cta?: {
        label?: string
        url?: string
        external?: boolean
    }[]
}

export default function EntryCard({
    className,
    isAnimated,
    boxColor,
    invert,
    image,
    video,
    title,
    content,
    cta
}: EntryCardProps) {
    return (
        <Section className={clsx('entry-card-component', className)}>
            <div className='container'>
                <div
                    className={clsx(
                        'entry-card-component__flex',
                        invert && 'entry-card-component__flex--invert'
                    )}
                    data-stagger-up={isAnimated ? 'true' : 'false'}
                >

                    <div className='entry-card-component__media'>
                        <div className='entry-card-component__media__wrapper'>
                        
                            {!video && image?.src && (
                                <Image
                                    src={{
                                        src: image?.src || '',
                                        width: 640,
                                        height: 700
                                    }}
                                    srcSmall={{
                                        src: image?.srcSmall || '',
                                        width: 500,
                                        height: 500
                                    }}
                                    alt={image?.alt || ''}
                                    className='cover'
                                    sizes='(max-width: 992px) 100vw, 650px'
                                />
                            )}

                            {video && (
                                <Video
                                    url={video.url}
                                    type={video.type}
                                    aspectRatio={video.aspectRatio}
                                    className='cover'
                                    background
                                />
                            )}

                        </div>
                    </div>

                    <div className='entry-card-component__content'>
                        {(title || content || cta) && (
                            <RoundedBox
                                className='entry-card-component__content__wrapper'
                                bgColor={boxColor}
                            >
                                <div className='entry-card-component__content__wrapper__inner'>

                                    {title && (
                                        <h2 className='h2'>
                                            {title}
                                        </h2>
                                    )}

                                    {content && (
                                        <RichText className='body'>
                                            {content}
                                        </RichText>
                                    )}

                                    {cta && (
                                        <div className='entry-card-component__ctas'>
                                            {cta.map((item, i) => (
                                                <Link
                                                    key={i}
                                                    href={item.url}
                                                    isExternal={item.external}
                                                    className='body'
                                                    label={{
                                                        underline: item.label
                                                    }}
                                                    icon={{
                                                        type: 'arrow-right'
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    )}

                                </div>
                            </RoundedBox>
                        )}
                    </div>

                </div>
            </div>
        </Section>
    )
}